module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [(_vm.rowData.organisation || _vm.rowData.person) ? _c('el-col', {
    attrs: {
      "span": this.isManager() ? 14 : 23
    }
  }, [_c('contacts-popover', {
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.isSuper()) ? _c('el-col', {
    attrs: {
      "span": _vm.rowData.organisation || _vm.rowData.person ? 8 : 23
    }
  }, [(_vm.isSuper() && !(_vm.rowData.category.indexOf('Xolas-Client') > 0)) ? _c('el-button', {
    attrs: {
      "icon": "fa fa-trash",
      "size": "small",
      "type": "danger",
      "circle": "",
      "disabled": _vm.isViewOnly() || _vm.rowData.active > 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df4010dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/controls/OrgControls.vue
// module id = 1724
// module chunks = 0